import type { StoreData } from "../controller";

export const isEccoStore = (store: StoreData) => store?.storeTypeId === "ECCO";
